import React from 'react'
import { UserAvatarProps } from './UserAvatar.types'

const UserAvatar: React.FC<UserAvatarProps> = ({
  username,
  size = 'md',
  onClick,
  className = '',
}) => {
  const sizeClasses = {
    sm: 'w-8 h-8 text-sm',
    md: 'w-10 h-10 text-base',
    lg: 'w-12 h-12 text-lg',
    navbar: 'w-8 h-8 sm:w-10 sm:h-10 text-base sm:text-lg',
  }

  const firstLetter = username?.charAt(0)?.toUpperCase() || '?'

  return (
    <div
      className={`flex items-center justify-center rounded-full active-gradient font-bold text-[var(--balance-text-color)] cursor-pointer hover:opacity-90 transition-opacity ${sizeClasses[size]} ${className}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => e.key === 'Enter' && onClick() : undefined}
    >
      {firstLetter}
    </div>
  )
}

export default UserAvatar
